<template>
	<div class="not-found">
		<div class="not-found__text">
			<h1>404</h1>
			<p>The page you're looking for doesn't exist.</p>
		</div>
		<v-btn
			variant="flat"
			color="primary"
			to="/home"
			>Go to Home</v-btn
		>
	</div>
</template>

<style scoped>
.not-found {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: var(--sgnl-space-32);
	min-height: 60vh;
	padding: var(--sgnl-space-32) var(--sgnl-space-24);
	text-align: center;
}

.not-found__text {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--sgnl-space-16);
}

.not-found h1 {
	font-size: var(--sgnl-font-size-h3);
	line-height: var(--sgnl-font-line-height-h3);
	color: var(--sgnl-default-primary-text);
}

.not-found p {
	font-size: var(--sgnl-font-size-paragraph-m);
	line-height: var(--sgnl-font-line-height-paragraph-m);
	color: var(--sgnl-default-secondary-text);
}
</style>
